var render, staticRenderFns
import script from "./FixedComp.vue?vue&type=script&lang=js&"
export * from "./FixedComp.vue?vue&type=script&lang=js&"
import style0 from "./FixedComp.vue?vue&type=style&index=0&id=22a44a24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a44a24",
  null
  
)

export default component.exports